<template>
  <div ref="main-carousel" class="main-carousel">
    <div class="main-carousel__list">
      <div class="main-carousel__item"
           v-for="item in carousel.images"
           :key="item.id"
      >
        <img :data-src="item.image"
             :alt="item.title"
             class="swiper-lazy"
        >
        <div class="swiper-lazy-preloader image-preloader"></div>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
  import Swiper from 'swiper'

  export default {
    name: 'MainCarousel',
    props: {
      carousel: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        index: null,
        swiper: null
      }
    },
    methods: {
      createSwiper() {
        this.swiper = new Swiper(this.$refs['main-carousel'], {
          wrapperClass: 'main-carousel__list',
          slideClass: 'main-carousel__item',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          speed: 600,
          effect: 'fade',
          watchSlidesVisibility: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          loop: true,
          autoplay: {
            delay: 10000,
            disableOnInteraction: false
          },
          lazy: {
            loadPrevNext: true
          }
        })
      },
      update() {
        this.swiper.destroy()
        setTimeout(() => {
          this.createSwiper()
        })
      }
    },
    mounted() {
      this.createSwiper()
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    },
    watch: {
      carousel() {
        this.update()
      }
    }
  }
</script>

<style>

</style>
